export interface FsLprRawFleetReadOwner {
  id: string;
  firstName: string;
  lastName: string;
}
